/**
 * #386 — Monitoring credentials API (admin only).
 * GET /api/eraf/admin/monitoring/credentials
 */
import { catalogApiClient } from './catalogApi';

export interface GrafanaViewerCredentials {
  viewerUsername: string;
  viewerPassword: string;
}

export interface MonitoringCredentials {
  grafana: GrafanaViewerCredentials;
}

export const monitoringApi = {
  getCredentials: async (): Promise<MonitoringCredentials> => {
    const response = await catalogApiClient.get<MonitoringCredentials>(
      '/admin/monitoring/credentials'
    );
    return response.data as unknown as MonitoringCredentials;
  },
};
